import { createSelector } from '@ngrx/store'

export const getStaticContentTemplatesState = createSelector(
  (state: any) => state.staticContentTemplates,
  (state: any) => state.get('list'),
)

export const getCreateStaticContentTemplateState = createSelector(
  (state: any) => state.staticContentTemplates,
  (state: any) => state.get('createStaticContentTemplate'),
)

export const getUpdateStaticContentTemplateState = createSelector(
  (state: any) => state.staticContentTemplates,
  (state: any) => state.get('updateStaticContentTemplate'),
)
